import { Col, Row, Space, Typography } from 'antd';
import footerIcon from 'assets/logo.jpg';
import React from 'react';
import * as S from './DealRoomFooter.styles';
const { Text } = Typography;

const DealRoomFooter: React.FC = () => {
  return (
    <S.FooterWrapper>
      <Row justify="space-between" align="middle">
        {/* Left Contact Info */}
        <Col>
          <Space size="large">
            <S.ContactItem>
              <Text className="label">טלפון</Text>
              <Text className="value">03-5020100</Text>
            </S.ContactItem>
            <S.ContactItem>
              <Text className="label">{'דוא"ל'}</Text>
              <Text className="value">office@baroz.co.il</Text>
            </S.ContactItem>
            <S.ContactItem>
              <Text className="label">כתובת משרד</Text>
              <Text className="value">הכישור 47 חולון</Text>
            </S.ContactItem>
            <S.ContactItem>
              <Text className="label">כתובת למשלוח דואר</Text>
              <Text className="value">ת.ד 338 חולון, 5810202</Text>
            </S.ContactItem>
          </Space>
        </Col>

        {/* Right Logo + Name */}
        <Col>
          <S.LogoWrapper>
            <h5 className="company-name">BAROZ.CO.IL</h5>
            <img src={footerIcon} alt="logo" />
          </S.LogoWrapper>
        </Col>
      </Row>
    </S.FooterWrapper>
  );
};

export default DealRoomFooter;
